import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  PaginatedEvent,
  QuerySearchEventsArgs,
} from '@tribeplatform/gql-client/types'
import { PaginatedEventFields } from '@tribeplatform/gql-client/types/generated'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useTribeClient,
} from '@tribeplatform/react-sdk'
import { getInfiniteSearchEventsKey } from '@tribeplatform/react-sdk/utils/keys'

type Props = {
  variables: QuerySearchEventsArgs
  fields?: PaginatedEventFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedEvent>
}

export const useInfiniteSearchEvents = ({
  variables,
  fields,
  useInfiniteQueryOptions,
}: Props) => {
  const { client } = useTribeClient()

  return useInfiniteQuery<PaginatedEvent, ClientError>(
    getInfiniteSearchEventsKey({ variables, fields }),
    ({ pageParam: after }) =>
      client.searchEvents({ after, ...variables }, fields),
    {
      refetchOnWindowFocus: false,
      ...useInfiniteQueryOptions,
    },
  )
}
